import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import Inventory from './Inventory';

const InventoryContainer = (props) => {
  const {
    inventoriesData: { inventories: { collection: data, totalCount } },
    isInventoriesFetching: isFetching,
  } = useInventoryTableContext();

  const {
    handlePageChange,
    handlePerPageChange,
    handleSortChange,
    params: {
      page,
      perPage,
      sortBy,
      sortOrder,
    },
  } = useFiltersContext();

  return (
    <Inventory
      { ...props }
      isFetching={ isFetching }
      data={ data }
      totalCount={ totalCount }
      page={ page }
      perPage={ perPage }
      sortBy={ sortBy }
      sortOrder={ sortOrder }
      paginate={ handlePageChange }
      itemsPerPage={ handlePerPageChange }
      sort={ handleSortChange }
    />
  );
};

export default InventoryContainer;
